




import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { Options, Dataset, Margin } from '../@types/Slide'
import { merge } from 'lodash'
import Colored from './Colored.vue'
import HeightAndWidth from './HeightAndWidth.vue'
import { ChartOptions, ChartDataSets, ChartData } from 'chart.js'

@Component({
  inheritAttrs: false
})
export default class Visualization extends Mixins(Colored, HeightAndWidth) {
  @Prop({ default: () => ({}) }) public data: ChartData
  @Prop({ default: () => ({}) }) public options: Options

  /**
   * Check if mounted.
   */
  public isMounted: boolean = false

  /**
   * Transformed data.
   */
  public __data: any = {}

  /**
   * Transformed options.
   */
  public __options: any = {}

  /**
   * Plugins
   */
  public __plugins: any = []

  /**
   * Default chart options.
   */
  public readonly defaultChartOptions: Options = {}

  /**
   * Base chart options.
   */
  public readonly baseChartOptions: Options = {}

  /**
   * Default data options.
   */
  public readonly defaultDatasetOptions: ChartDataSets = {}

  /**
   * Global default options.
   */
  public readonly baseDatasetOptions: ChartDataSets = {}

  /**
   * Global basic plugins.
   */
  public readonly baseChartPlugins: any[] = []

  /**
   * Custom plugins.
   */
  public readonly plugins: any[] = []

  /**
   * On created hook.
   */
  created() {
    this.__data = this.colorOptionsToColors({
      ...this.data,
      datasets: this.data.datasets
        ? this.data.datasets.map(dataset =>
            merge(dataset, this.defaultDatasetOptions, this.baseDatasetOptions)
          )
        : []
    })

    this.__options = this.colorOptionsToColors(
      merge(this.baseChartOptions, this.defaultChartOptions, this.options)
    )

    this.__plugins = merge(this.baseChartPlugins, this.plugins)
  }

  /**
   * On mounted hook.
   */
  mounted() {
    this.isMounted = true
  }
}
